import React from 'react';

import LectureChangeLog from '../lecturechangelog/LectureChangeLog';
import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import { useMutation } from 'react-query';
import { LectureUpdateVersionService } from 'services/core';

import UpdateIcon from 'assets/icons/update-icon.svg';

import { MOBILE_FULLSCREEN, CONFIRMATION } from '@core/constants/ModalTypes';

import classes from './LectureVersion.module.scss';

const LectureVersion = ({
	title,
	description,
	show_changelog,
	show_update_button,
	id,
	lecture_title,
	confirm_message
}) => {
	const { toast, ToastContainer } = UseToast();
	const { showModal, destroyModal, show } = UseModal();
	const {
		destroyModal: destroyConfirmModal,
		show: showConfirmModal,
		showModal: handleShowConfirmtModal
	} = UseModal()
	const { mutate: updateLectureVersion, isLoading: LecutreUpdateLoading } = useMutation(
		LectureUpdateVersionService,
		{
			onSuccess: (data) => {
				toast(data.data?.message);
				destroyConfirmModal();
				setTimeout(() => window?.location.reload(), 2000);
			},
			onError: (error) => {
				toast(error.response.data.data, 'Alert');
			}
		}
	);
	return (
		<>
			<div
				className={`${classes['lecture-version-box']} d-flex flex-column align-items-center justify-content-center p-3 w-100 gap-3 text-center`}>
				<UpdateIcon data-testid="lecture-update-icon" />
				<h5>{title}</h5>
				<p>{description}</p>
				{show_changelog && (
					<ActionButton className="w-100" kind="blank" onClick={() => showModal()}>
						View full change log
					</ActionButton>
				)}
				{show_update_button && (
					<ActionButton
						onClick={() => handleShowConfirmtModal()}
						kind="secondary"
						disabled={LecutreUpdateLoading}
						loading={LecutreUpdateLoading}>
						Update to the latest version
					</ActionButton>
				)}
			</div>
			<Modal
				title={
					<div
						className={`${classes['changelog-header']} d-flex flex-column align-items-center justify-content-center`}>
						<h3>ChangeLog</h3>
						<h5>{lecture_title}</h5>
					</div>
				}
				closeHandler={destroyModal}
				show={show}
				type={MOBILE_FULLSCREEN}>
				<div className={`${classes['changelog-wrapper']}`}>
					<LectureChangeLog id={id} />
				</div>
			</Modal>
			<Modal
				header={false}
				show={showConfirmModal}
				closeHandler={destroyConfirmModal}
				type={CONFIRMATION}
			>
				<div
					className={`${classes["modal-confirmation"]} d-flex flex-column align-items-start`}
					style={{ minWidth: '40vw' }}
				>
					<p>{confirm_message}</p>
					<div className='d-flex justify-content-end w-100 mt-4'>
						<ActionButton kind='simple' onClick={() => destroyConfirmModal()}>No</ActionButton>
						<ActionButton kind='simple-alert' onClick={() => updateLectureVersion(id)}>Yes</ActionButton>
					</div>
				</div>
			</Modal>
			<ToastContainer />
		</>
	);
};

export default LectureVersion;
